import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-K2RX9E963T';

let hasInitialized = false;

export function initializeAnalytics() {
  if (hasInitialized || typeof window === 'undefined') {
    return;
  }

  ReactGA.initialize(MEASUREMENT_ID, {
    gtagOptions: {
      send_page_view: false,
    },
  });

  hasInitialized = true;
  trackPageView();
}

export function trackPageView(path = window.location.pathname + window.location.search) {
  if (!hasInitialized) {
    return;
  }

  ReactGA.send({
    hitType: 'pageview',
    page: path,
  });
}
